export const metalsCodes = ["CPR", "XAG", "XAU", "XPD", "XPT"];

export const countryCodes = [
  "AFG",
  "AGO",
  "ALB",
  "AND",
  "ARE",
  "ARG",
  "ARM",
  "ATG",
  "AUS",
  "AUT",
  "AZE",
  "BDI",
  "BEL",
  "BEN",
  "BFA",
  "BGD",
  "BGR",
  "BHR",
  "BHS",
  "BIH",
  "BLR",
  "BLZ",
  "BOL",
  "BRA",
  "BRB",
  "BRN",
  "BTN",
  "BWA",
  "CAF",
  "CAN",
  "CHE",
  "CHL",
  "CHN",
  "CIV",
  "CMR",
  "COD",
  "COG",
  "COL",
  "COM",
  "CPV",
  "CRI",
  "CUB",
  "CYP",
  "CZE",
  "DEU",
  "DJI",
  "DMA",
  "DNK",
  "DOM",
  "ECU",
  "EGY",
  "ERI",
  "ESP",
  "EST",
  "ETH",
  "EUR",
  "FIN",
  "FJI",
  "FRA",
  "FSM",
  "GAB",
  "GBR",
  "GEO",
  "GHA",
  "GIN",
  "GMB",
  "GNB",
  "GNQ",
  "GRC",
  "GRD",
  "GTM",
  "GUY",
  "HND",
  "HRV",
  "HTI",
  "HUN",
  "IDN",
  "IND",
  "IRL",
  "IRN",
  "IRQ",
  "ISL",
  "ISR",
  "ITA",
  "JAM",
  "JOR",
  "JPN",
  "KAZ",
  "KEN",
  "KGZ",
  "KHM",
  "KIR",
  "KNA",
  "KOR",
  "KWT",
  "LAO",
  "LBN",
  "LBR",
  "LBY",
  "LCA",
  "LIE",
  "LKA",
  "LSO",
  "LTU",
  "LUX",
  "LVA",
  "MAR",
  "MCO",
  "MDA",
  "MDG",
  "MDV",
  "MEX",
  "MHL",
  "MKD",
  "MLI",
  "MLT",
  "MMR",
  "MNE",
  "MNG",
  "MOZ",
  "MRT",
  "MUS",
  "MWI",
  "MYS",
  "NAM",
  "NER",
  "NGA",
  "NIC",
  "NLD",
  "NOR",
  "NPL",
  "NRU",
  "NZL",
  "OMN",
  "PAK",
  "PAN",
  "PER",
  "PHL",
  "PLW",
  "PNG",
  "POL",
  "PRK",
  "PRT",
  "PRY",
  "QAT",
  "ROU",
  "RUS",
  "RWA",
  "SAU",
  "SDN",
  "SEN",
  "SGP",
  "SLB",
  "SLE",
  "SLV",
  "SMR",
  "SOM",
  "SRB",
  "SSD",
  "STP",
  "SUR",
  "SVK",
  "SVN",
  "SWE",
  "SWZ",
  "SYC",
  "SYR",
  "TCD",
  "TGO",
  "THA",
  "TJK",
  "TKM",
  "TLS",
  "TON",
  "TTO",
  "TUN",
  "TUR",
  "TUV",
  "TZA",
  "UGA",
  "UKR",
  "URY",
  "USD",
  "UZB",
  "VCT",
  "VEN",
  "VNM",
  "VUT",
  "WSM",
  "YEM",
  "ZAF",
  "ZMB",
  "ZWE",
];

export const cryptoCodes = [
  "AAVE",
  "ADA",
  "AIOZ",
  "ALGO",
  "APE",
  "APT",
  "ARB",
  "ATOM",
  "AXL",
  "AXS",
  "BCH",
  "BNB",
  "BONK",
  "BTC",
  "BTG",
  "BTT",
  "CAKE",
  "CFX",
  "CHZ",
  "COMP",
  "CRO",
  "DAI",
  "DOGE",
  "DOT",
  "EGLD",
  "ENA",
  "ENS",
  "EOS",
  "ETC",
  "ETH",
  "FET",
  "FIL",
  "FLOW",
  "FTM",
  "FTT",
  "GALA",
  "GNO",
  "GRT",
  "GT",
  "HBAR",
  "HTN",
  "ICP",
  "IMX",
  "INJ",
  "JASMY",
  "JUP",
  "KAVA",
  "KCS",
  "KLAY",
  "LDO",
  "LEO",
  "LINK",
  "LPT",
  "LTC",
  "LUNC",
  "MANA",
  "MATIC",
  "MKR",
  "NEAR",
  "NEO",
  "NEXO",
  "OKB",
  "OM",
  "PAXG",
  "PEPE",
  "QNT",
  "RNDR",
  "ROSE",
  "RUNE",
  "SAND",
  "SHIB",
  "SNX",
  "SOL",
  "THETA",
  "TON",
  "TRX",
  "TUSD",
  "TWT",
  "UNI",
  "USDC",
  "USDD",
  "VET",
  "WIF",
  "WLD",
  "XAUT",
  "XDC",
  "XEC",
  "XLM",
  "XMR",
  "XRP",
  "XTZ",
  "ZEC",
  "ZIL",
];

export const commoditiesCode = [
  "CCO",
  "CFF",
  "CTN",
  "CRN",
  "GAS",
  "OIL",
  "NGS",
  "SOY",
  "WHT",
  "SGR",
];

export const commonCodes = [
  // METALS
  "CPR",
  "XAG",
  "XAU",
  "XPD",
  "XPT",
  // COMMODITIES
  "CCO",
  "CFF",
  "CTN",
  "GAS",
  "OIL",
  "NGS",
  "SOY",
  "WHT",
  // crypto
  "AAVE",
  "ADA",
  "AIOZ",
  "ALGO",
  "APE",
  "APT",
  "ARB",
  "ATOM",
  "AXL",
  "AXS",
  "BCH",
  "BNB",
  "BONK",
  "BTC",
  "BTG",
  "BTT",
  "CAKE",
  "CFX",
  "CHZ",
  "COMP",
  "CRO",
  "DAI",
  "DOGE",
  "DOT",
  "EGLD",
  "ENA",
  "ENS",
  "EOS",
  "ETC",
  "ETH",
  "FET",
  "FIL",
  "FLOW",
  "FTM",
  "FTT",
  "GALA",
  "GNO",
  "GRT",
  "GT",
  "HBAR",
  "HTN",
  "ICP",
  "IMX",
  "INJ",
  "JASMY",
  "JUP",
  "KAVA",
  "KCS",
  "KLAY",
  "LDO",
  "LEO",
  "LINK",
  "LPT",
  "LTC",
  "LUNC",
  "MANA",
  "MATIC",
  "MKR",
  "NEAR",
  "NEO",
  "NEXO",
  "OKB",
  "OM",
  "PAXG",
  "PEPE",
  "QNT",
  "RNDR",
  "ROSE",
  "RUNE",
  "SAND",
  "SHIB",
  "SNX",
  "SOL",
  "THETA",
  "TON",
  "TRX",
  "TUSD",
  "TWT",
  "UNI",
  "USDC",
  "USDD",
  "VET",
  "WIF",
  "WLD",
  "XAUT",
  "XDC",
  "XEC",
  "XLM",
  "XMR",
  "XRP",
  "XTZ",
  "ZEC",
  "ZIL",
  // forex
  "AFG",
  "AGO",
  "ALB",
  "AND",
  "ARE",
  "ARG",
  "ARM",
  "ATG",
  "AUS",
  "AUT",
  "AZE",
  "BDI",
  "BEL",
  "BEN",
  "BFA",
  "BGD",
  "BGR",
  "BHR",
  "BHS",
  "BIH",
  "BLR",
  "BLZ",
  "BOL",
  "BRA",
  "BRB",
  "BRN",
  "BTN",
  "BWA",
  "CAF",
  "CAN",
  "CHE",
  "CHL",
  "CHN",
  "CIV",
  "CMR",
  "COD",
  "COG",
  "COL",
  "COM",
  "CPV",
  "CRI",
  "CUB",
  "CYP",
  "CZE",
  "DEU",
  "DJI",
  "DMA",
  "DNK",
  "DOM",
  "ECU",
  "EGY",
  "ERI",
  "ESP",
  "EST",
  "ETH",
  "EUR",
  "FIN",
  "FJI",
  "FRA",
  "FSM",
  "GAB",
  "GBR",
  "GEO",
  "GHA",
  "GIN",
  "GMB",
  "GNB",
  "GNQ",
  "GRC",
  "GRD",
  "GTM",
  "GUY",
  "HND",
  "HRV",
  "HTI",
  "HUN",
  "IDN",
  "IND",
  "IRL",
  "IRN",
  "IRQ",
  "ISL",
  "ISR",
  "ITA",
  "JAM",
  "JOR",
  "JPN",
  "KAZ",
  "KEN",
  "KGZ",
  "KHM",
  "KIR",
  "KNA",
  "KOR",
  "KWT",
  "LAO",
  "LBN",
  "LBR",
  "LBY",
  "LCA",
  "LIE",
  "LKA",
  "LSO",
  "LTU",
  "LUX",
  "LVA",
  "MAR",
  "MCO",
  "MDA",
  "MDG",
  "MDV",
  "MEX",
  "MHL",
  "MKD",
  "MLI",
  "MLT",
  "MMR",
  "MNE",
  "MNG",
  "MOZ",
  "MRT",
  "MUS",
  "MWI",
  "MYS",
  "NAM",
  "NER",
  "NGA",
  "NIC",
  "NLD",
  "NOR",
  "NPL",
  "NRU",
  "NZL",
  "OMN",
  "PAK",
  "PAN",
  "PER",
  "PHL",
  "PLW",
  "PNG",
  "POL",
  "PRK",
  "PRT",
  "PRY",
  "QAT",
  "ROU",
  "RUS",
  "RWA",
  "SAU",
  "SDN",
  "SEN",
  "SGP",
  "SLB",
  "SLE",
  "SLV",
  "SMR",
  "SOM",
  "SRB",
  "SSD",
  "STP",
  "SUR",
  "SVK",
  "SVN",
  "SWE",
  "SWZ",
  "SYC",
  "SYR",
  "TCD",
  "TGO",
  "THA",
  "TJK",
  "TKM",
  "TLS",
  "TON",
  "TTO",
  "TUN",
  "TUR",
  "TUV",
  "TZA",
  "UGA",
  "UKR",
  "URY",
  "USD",
  "UZB",
  "VCT",
  "VEN",
  "VNM",
  "VUT",
  "WSM",
  "YEM",
  "ZAF",
  "ZMB",
  "ZWE",
];

// Define IconProps and IconComponentType
interface IconProps {
  className?: string;
  style?: React.CSSProperties;
  txt?: string; // Optional prop for Avatar
}

type IconComponentType = React.FC<IconProps>;

// Define the type for icons object
export type IconsType = {
  [key: string]: React.LazyExoticComponent<IconComponentType>;
};
